















































































import VueBase from '@/VueBase'
import { Component } from 'vue-property-decorator'
@Component({
  name: 'StatusMonitoring',
})
export default class StatusMonitoring extends VueBase {
  private logo = '/upload/assets/img/logo.png?v=' + String(Math.random())
  private logo_en = '/upload/assets/img/logo_en.png?v=' + String(Math.random())
  private now_version = ''
  private new_version = ''
  private versionVisible = false
  private versionMap: any = {}
  private versionString = ''
  private async getVersion() {
    const res = await this.services.setting.version()
    this.new_version = res.data.tag_name.substr(1)
  }
  private async getNowVersion() {
    const res = await this.services.setting.nowVersion()
    const versionArr = res.data.split('\n')
    versionArr.pop()
    versionArr.forEach((item: any) => {
      const itemArr = item.split(',')
      const name = itemArr[0]
      const key = itemArr[1]
      const value = itemArr[2]
      if (this.versionMap[name]) {
        this.versionMap[name][key] = value
      } else {
        this.versionMap[name] = {
          [key]: value,
        }
      }
    })

    const res2 = await this.services.setting.versionlist()
    if (res2.status === 201) {
      this.versionMap = { ...res2.data, ...this.versionMap }
    }
    this.now_version = this.versionMap.DongTai.version
    this.versionString = JSON.stringify(this.versionMap)
  }
  private onError() {
    this.$message({
      showClose: true,
      message: this.$t('views.search.copyFail') as string,
      type: 'error',
    })
  }
  private onCopy() {
    this.$message({
      showClose: true,
      message: this.$t('views.search.copySuccess') as string,
      type: 'success',
    })
  }
  private toUpdate() {
    window.open(`https://docs.dongtai.io/docs/changelog/release-note`)
  }
  private toHelp() {
    window.open('https://doc.dongtai.io/')
  }

  private toBug() {
    window.open('https://github.com/HXSecurity/DongTai/issues')
  }
  created() {
    this.getNowVersion()
    this.getVersion()
  }
}
